import { FormGroup, ValidationErrors } from '@angular/forms';
import { ProductTypeEnum } from 'src/app/product-capture/model/enums/product-capture.enums';

export function chooserCurrencyAndAssetsValidator() {
  return (summaryGroup: FormGroup): ValidationErrors | null => {
    const productType = summaryGroup.get('productType')?.value;
    const currencyControl = summaryGroup.get('currency');
    const assetsControl = summaryGroup
      .get('underlyingAssetsGroup')
      ?.get('underlyingAssets');

    if (productType !== ProductTypeEnum.CHOOSER || !currencyControl.value) {
      assetsControl.setErrors(null);
      return null;
    }

    if (assetsControl.value?.length != 2 || assetsControl.value?.some((asset: any) => !asset.assetId)) {
      assetsControl.setErrors({
        required: true,
        message: 'Two FX pairs are required for Chooser products',
      });

      return;
    }

    if (
      !assetsControl.value.every(
        (asset: any) => asset.currency == currencyControl.value
      )
    ) {
      assetsControl.setErrors({
        incorrect: true,
        message: 'Currency and FX pairs do not match',
      });
      assetsControl.markAllAsTouched();
    } else {
      assetsControl.setErrors(null);
    }

    return null;
  };
}
